import { Component, Input, OnInit } from '@angular/core';
import { I18NextService } from 'angular-i18next';
import { WasabiDetail } from 'mbs-ui-shared@components/components/models/license.model';
import { getTableHeaders } from 'mbs-ui-shared@components/licenses/components/wasabi-table/constants/table';
import { tableMaxHeight } from 'mbs-ui-shared@constants';

@Component({
  selector: 'mbs-wasabi-table',
  templateUrl: './wasabi-table.component.html'
})
export class WasabiTableComponent implements OnInit {
  @Input() licenses: Array<WasabiDetail>;
  @Input() period: string;
  @Input() total: number;

  public loading = false;

  public headers;

  public tableMaxHeight = tableMaxHeight;

  constructor(private i18n: I18NextService) {}

  ngOnInit() {
    this.headers = getTableHeaders(this.i18n);
  }
}
